(()=>{
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  const root=document.getElementById(("YurchakLoyaltyCapture-" + __shopifySectionId + ""));
  if(!root||root.dataset.ylcBound==='1')return;
  root.dataset.ylcBound='1';
  const panel=root.querySelector('[data-ylc-panel]');
  const close=root.querySelector('[data-ylc-close]');
  const toast=root.querySelector('[data-ylc-toast]');
  const success=root.querySelector('[data-ylc-success]');
  const error=root.querySelector('[data-ylc-error]');
  const key='yurchak_loyalty_capture_v1';
  const day=86400000;
  const delay=Number(root.dataset.delay||8000);
  const dismissDays=Math.max(1,Number(root.dataset.dismissDays||7));
  const design=root.dataset.designMode==='true';
  let state={};
  try{state=JSON.parse(localStorage.getItem(key)||'{}')}catch(_){}
  const save=(type,days)=>{try{localStorage.setItem(key,JSON.stringify({type,until:Date.now()+days*day}))}catch(_){}};
  const active=()=>state.until&&state.until>Date.now();
  const open=()=>{panel.hidden=false};
  const hide=()=>{panel.hidden=true};
  const showToast=()=>{toast.hidden=false;window.setTimeout(()=>toast.hidden=true,5000)};

  if(success){save('subscribed',365);hide();showToast()}
  else if(error)open();
  else if(design)open();
  else if(!active())window.setTimeout(open,Math.max(0,delay));

  close?.addEventListener('click',()=>{
    save('dismissed',dismissDays);
    state={type:'dismissed',until:Date.now()+dismissDays*day};
    hide();
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&!panel.hidden){
      save('dismissed',dismissDays);
      state={type:'dismissed',until:Date.now()+dismissDays*day};
      hide();
    }
  });
  window.addEventListener('yurchak:loyalty-subscribed',()=>{save('subscribed',365);hide()});
})();
